/*
  PANDECTES COOKIE BANNER: custom styles (philipkarto.com)
 
  Where to paste: Online Store > Themes > Edit code > layout/theme.liquid,
  inside <script> ... </script> tags, near the TOP of <head> so the styling is
  ready the moment the banner appears.
 
  What it does
  - Mobile (<= 749px): removes the cross, shows a compact bottom bar (max 24% of
    screen height) with Accept and Decline side by side.
  - Desktop: bigger, higher-contrast close button (44x44) away from the edge.
  - Accept = black button, Decline = white button (all screen sizes).
*/
(function () {
  var STYLE_ID = 'custom-pandectes-styles';
 
  var CSS = `
    .actions button[data-cb="accept"] { background: #000 !important; color: #fff !important; border: 1px solid #000 !important;}
    .actions button[data-cb="decline"] { background: #fff !important; color: #000 !important; border: 1px solid #000 !important;}
    .actions button[data-cb="accept"], .actions button[data-cb="decline"] { min-height: 44px !important; font-weight: 600 !important; cursor: pointer;}
    .close svg { width: 12px !important; height: 12px !important; color: #000 !important; fill: #000 !important;}
    .body>.intro>.links { display: inline-block !important;}
    .inner { padding: 10px !important; gap: 10px !important; }   
    .actions { display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; gap: 8px !important; margin: 0 !important;}
    .actions button[data-cb="accept"], .actions button[data-cb="decline"], .actions button[data-cb="prefs"] { flex: 1 1 calc(33% - 4px) !important; width: auto !important; margin: 0 !important;}
    .actions button[data-cb="prefs"] { font-weight: 600 !important; cursor: pointer; }

    @media (max-width: 900px) {
    .inner>.header, .inner>.body, .inner>.actions { padding: 0 !important; }
    .inner>.header+.body { grid-column: span 2 / span 2 !important;}    
    .close { display: none !important;}
    .inner { padding: 10px !important; gap: 10px !important; }
    .body { margin: 0 !important;}
    .body, .body p, .body span { font-size: 13px !important; line-height: 1.35 !important;}
    .body p { margin: 0 !important; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;}
    .actions { display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; gap: 8px !important; margin: 0 !important;}
    .actions button[data-cb="accept"], .actions button[data-cb="decline"] { flex: 1 1 calc(33% - 4px) !important; width: auto !important; margin: 0 !important; }
    .actions button[data-cb="prefs"] { flex: 1 1 calc(33% - 4px) !important; padding: 0; border: none; text-decoration: underline; font-weight: 600 !important; cursor: pointer;}
    }
  `;
 
  // Label the buttons by their text so styling doesn't depend on class names
  function tagButtons(shadow) {
    var buttons = shadow.querySelectorAll('.actions button');
    buttons.forEach(function (btn, i) {
      if (btn.getAttribute('data-cb')) return;
      var t = (btn.textContent || '').trim().toLowerCase();
      var role = null;
      if (/accept|allow|agree/.test(t)) role = 'accept';
      else if (/decline|reject|deny/.test(t)) role = 'decline';
      else if (/prefer|manage|setting|customi/.test(t)) role = 'prefs';
      else role = ['accept', 'decline', 'prefs'][i] || null; // fallback: DOM order
      if (role) btn.setAttribute('data-cb', role);
    });
  }
 
  function applyPandectesStyles() {
    var cmp = document.querySelector('pandectes-cmp');
    if (!cmp || !cmp.shadowRoot) return false;
 
    var shadow = cmp.shadowRoot;
    var style = shadow.querySelector('#' + STYLE_ID);
 
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      shadow.appendChild(style);
    }
    style.textContent = CSS;
 
    tagButtons(shadow);
 
    // Buttons may render after the shadow root exists: keep tagging as it changes
    if (!shadow.__cbObserver) {
      shadow.__cbObserver = new MutationObserver(function () { tagButtons(shadow); });
      shadow.__cbObserver.observe(shadow, { childList: true, subtree: true });
    }
    return true;
  }
 
  if (!applyPandectesStyles()) {
    var observer = new MutationObserver(function () {
      if (applyPandectesStyles()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();